/**
 * Hook for consuming the ProductContext
 */

import { useContext } from "react";
import {
  ProductContext,
  type ProductContextValue,
} from "@/contexts/ProductContext";

export function useProduct(): ProductContextValue {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error("useProduct must be used within a <ProductProvider>");
  }
  return context;
}
